import { UserAvatar } from './user-avatar'

interface UserCardProps {
  firstName: string
  lastName: string
  description: React.ReactNode
  avatar?: string
}

export const UserCard = ({ firstName, lastName, description, avatar }: UserCardProps) => (
  <div className="flex items-center gap-2 min-w-0">
    <UserAvatar firstName={firstName} lastName={lastName} avatar={avatar} />

    <div className="flex flex-col gap-0.5 items-start min-w-0">
      <span className="text-black truncate w-full">
        {firstName} {lastName}
      </span>
      <span className="text-xs text-muted-foreground flex items-center gap-1 truncate w-full">
        {description}
      </span>
    </div>
  </div>
)
